import { reduxActionTypePrefix } from "../../../constants/module.constants.js";
const prefix = `${reduxActionTypePrefix}/VIEW`;
export {
  prefix
};
//# sourceMappingURL=constants.js.map
